import { useEffect } from "react";
import { useSearchParams, type NavigateFunction } from "react-router-dom";

const PREFIX = "crm.apply.";

/**
 * Opens a list page with filters already set, in the same shape as that page's saved views (Ask the CRM's
 * "Open in list"). The settings wait in this tab's sessionStorage under a one-time key, so the link stays short.
 */
export function openWithConfig(navigate: NavigateFunction, path: string, config: Record<string, unknown>) {
  const key = Math.random().toString(36).slice(2, 10);
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(config));
  } catch {
    /* storage off: the page just opens unfiltered */
  }
  navigate(`${path}?apply=${key}`);
}

/** On a list page: applies settings handed over with ?apply=<key> once, using the page's own saved-view apply */
export function ApplyFromUrl({ apply }: { apply: (config: any) => void }) {
  const [params, setParams] = useSearchParams();
  const key = params.get("apply");
  useEffect(() => {
    if (!key) return;
    let config: unknown = null;
    try {
      config = JSON.parse(sessionStorage.getItem(PREFIX + key) || "null");
      sessionStorage.removeItem(PREFIX + key);
    } catch {
      config = null;
    }
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete("apply");
        return next;
      },
      { replace: true },
    );
    // After the URL settles, so a page that keeps its view in the URL (Tasks) doesn't put ?apply back
    if (config && typeof config === "object") setTimeout(() => apply(config), 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return null;
}
